import { type Tag } from '../types/Tag';

export function convertTagIdsToTags(tagIds: number[], tags: Tag[]): Tag[] {
  return tagIds
    .map((tagId) => tags.find((t) => t.id === tagId) || undefined)
    .filter(Boolean) as Tag[];
}
